import { Injectable, Inject, forwardRef } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

@Injectable()
export class RCInterceptor implements HttpInterceptor {

	constructor() {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//console.log("RCInterceptor - req", req);
		if(req.body) {
			let responseTypeReq = req.responseType;

			let downloadUrlBoolean = req.url.indexOf("/api/downloads");
			//console.log("RCInterceptor - downloadUrlBoolean", responseTypeReq, downloadUrlBoolean);
			if(downloadUrlBoolean != -1){
				responseTypeReq = 'blob';
			}

			let simulaPraticaUrlBoolean = req.url.indexOf("/api/pratiche/simula");
			//console.log("RCInterceptor - simulaPraticaUrlBoolean", responseTypeReq, simulaPraticaUrlBoolean);
			if(simulaPraticaUrlBoolean != -1){
				responseTypeReq = 'blob';
			}

			const duplicate = req.clone({ responseType: responseTypeReq });
			//console.log("RCInterceptor - duplicate", duplicate);
			return next.handle(duplicate)
			.do((event: any) => {
					if (event instanceof HttpResponse) {
						//console.log('RCInterceptor - res', event);
					}
				}
			)
			.catch(error => {
				//debugger;
				return Observable.of(error);
			});
		}
		return next.handle(req);
	}
}
